import { Box, Button } from '@mui/material';
import { generatePath, Link } from 'react-router';
import { Trans, useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { RoutePaths } from '../../routes/AppRoutes';
import { useNavBlocker } from '../../hooks/useNavBlocker';
import { draftProductAtom } from './state';

interface ProductFormQuitBtnProps {
  productId: string | undefined;
  shouldBlock: boolean;
}

export default function ProductFormQuitBtn({ productId, shouldBlock }: ProductFormQuitBtnProps): React.JSX.Element {
  const { t } = useTranslation(['products', 'common']);
  const draftProduct = useAtomValue(draftProductAtom);
  const blockerMessage = {
    title: t('products:abort_form'),
    message: <Trans i18nKey="products:abort_form_message" />,
    confirmLabel: t('common:confirm'),
    cancelLabel: t('common:cancel'),
  };
  const blockerModal = useNavBlocker(shouldBlock, blockerMessage);

  return (
    <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
      {blockerModal}
      <Button
        sx={{ width: { xs: '100%', sm: 'auto' } }}
        variant="outlined"
        component={Link}
        to={
          !draftProduct?.sku
            ? generatePath(RoutePaths.COMPANY_PRODUCTS)
            : generatePath(RoutePaths.PRODUCT, { productSku: `${draftProduct!.sku!}`, companyId: draftProduct!.company_id! })
        }
      >
        {t(productId ? 'common:quit' : 'common:cancel')}
      </Button>
    </Box>
  );
}
